module.exports = __webpack_public_path__ + "assets/images/Inactive.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Inactive.png
// module id = 391
// module chunks = 1